import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import {
  MenuList,
  MenuListItem,
  MaterialIcon,
  HOCs,
} from '@pearsontechnology/aero-components';

import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import { PermissionTypes, ActionTypes } from 'constants/enums';

import messages from './messages';
import ProjectActionButton from './ProjectActionButton';
import { Menu, MenuListItemText } from './styles';

const { enhanceWithPopper } = HOCs;
const ButtonWithPopper = enhanceWithPopper(ProjectActionButton);

const ProjectActions = ({ onActionsMenuItemClick, projectId, permissionLevel, isGrey }) => {
  const [list, setList] = useState([]);

  useEffect(() => {
    if (permissionLevel === PermissionTypes.OWNER) {
      const actionsList = [];
      actionsList.push({
        type: ActionTypes.MOVE,
        icon: 'arrow_forward',
        message: messages.listItemActionMove,
      }, {
        type: ActionTypes.DELETE,
        icon: 'delete',
        message: messages.listItemActionDelete,
      });
      setList(actionsList);
    }
  }, [permissionLevel]);

  if (!list.length) {
    return <div />;
  }

  const onClickItem = (type) => (event) => {
    event.preventDefault();
    onActionsMenuItemClick(type, projectId);
  };

  return (
    <ButtonWithPopper placement="bottom-end" hidePopperOnClick isGrey={isGrey}>
      <Menu>
        <MenuList>
          {
            list.map((listItem) => (
              <MenuListItem key={listItem.type} onClick={onClickItem(listItem.type)}>
                <MaterialIcon id={listItem.icon} />
                <MenuListItemText>
                  {intl.formatMessage(listItem.message)}
                </MenuListItemText>
              </MenuListItem>
            ))
          }
        </MenuList>
      </Menu>
    </ButtonWithPopper>
  );
};

ProjectActions.propTypes = {
  permissionLevel: PropTypes.oneOf([
    PermissionTypes.OWNER,
    PermissionTypes.CONTRIBUTOR,
    PermissionTypes.REVIEWER,
  ]),
  onActionsMenuItemClick: PropTypes.func.isRequired,
  projectId: PropTypes.string.isRequired,
  isGrey: PropTypes.bool,
};

export default ProjectActions;
